import React from 'react';
import './masterScheduleTimesForm.css';
import { useDispatch, useSelector } from "react-redux";
import { setMasterScheduleTimesFormAction } from "../../redux/rootReducer";
import { MASTER_SCHEDULE_TIMES_FORM_INITIAL } from "../../redux/initialStateConstant";
import { UpdateScheduleThunk } from "../../redux/thunks/UpdateScheduleThunk";

const MasterScheduleTimesForm = () => {
    const dispatch = useDispatch();
    const master_schedule_times_form = useSelector(state => state.master_schedule_times_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setMasterScheduleTimesFormAction(MASTER_SCHEDULE_TIMES_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">{ `Расписание на ${ new Date(master_schedule_times_form.date).toLocaleDateString('ru-Ru') }` }</div>
                    </div>
                    <div className="form__field">
                        <div className="times">
                            {
                                master_schedule_times_form.times.map((elem, index) => {
                                    return(
                                        <div
                                            key={ index }
                                            className="time"
                                        >
                                            <input type="time" className="input"
                                                value={ elem.from }
                                                onChange={ (event) => {
                                                    // Копируем массив times
                                                    let times_copy = [...master_schedule_times_form.times];
                                                    times_copy[index] = { ...times_copy[index], from: event.target.value };

                                                    dispatch(setMasterScheduleTimesFormAction({
                                                        ...master_schedule_times_form,
                                                        times: times_copy
                                                    }));
                                                } }

                                            />
                                            <input type="time" className="input"
                                                value={ elem.to }
                                                onChange={ (event) => {
                                                    // Копируем массив times
                                                    let times_copy = [...master_schedule_times_form.times];
                                                    times_copy[index] = { ...times_copy[index], to: event.target.value };

                                                    dispatch(setMasterScheduleTimesFormAction({
                                                        ...master_schedule_times_form,
                                                        times: times_copy
                                                    }));
                                                } }
                                            />
                                            <div className="control control--remove"
                                                onClick={ () => {
                                                    let times_copy = [...master_schedule_times_form.times];
                                                    times_copy.splice(index, 1);

                                                    dispatch(setMasterScheduleTimesFormAction({
                                                        ...master_schedule_times_form,
                                                        times: times_copy
                                                    }));
                                                } }
                                            />
                                        </div>
                                    );
                                })
                            }
                            <div className="input__caption" style={{ marginBottom: -10 }}>Новый интервал</div>
                            <div className="time">
                                <input type="time" className="input"
                                    value={ master_schedule_times_form.new_time_from }
                                    onChange={ event => {
                                        dispatch(setMasterScheduleTimesFormAction({
                                            ...master_schedule_times_form,
                                            new_time_from: event.target.value
                                        }));
                                    } }
                                />
                                <input type="time" className="input"
                                    value={ master_schedule_times_form.new_time_to }
                                    onChange={ event => {
                                        dispatch(setMasterScheduleTimesFormAction({
                                            ...master_schedule_times_form,
                                            new_time_to: event.target.value
                                        }));
                                   } }
                                />
                                <div className="control control--apply"
                                    onClick={ () => {
                                        let times_copy = [
                                            ...master_schedule_times_form.times,
                                            {
                                                from: master_schedule_times_form.new_time_from,
                                                to: master_schedule_times_form.new_time_to
                                            }
                                        ];

                                        dispatch(setMasterScheduleTimesFormAction({
                                            ...master_schedule_times_form,
                                            times: times_copy,
                                            new_time_from: '',
                                            new_time_to: ''
                                        }));
                                    } }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(UpdateScheduleThunk({
                                    master_id: master_schedule_times_form.master_id,
                                    date: master_schedule_times_form.date,
                                    times: JSON.stringify(master_schedule_times_form.times)
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MasterScheduleTimesForm;